import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AlertaService } from "../../services/alerta.service";
import { catchError, exhaustMap, map, tap } from "rxjs/operators";
import { of } from "rxjs";
import { findWithholdingCatalogAct, loadWithholdingCatalogByIdAct, saveWithholdingCatalogAct, saveSuccessWithholdingCatalogAct, 
    setViolationsWithholdingCatalogAct, showMsgErrorAct, updateWithholdingCatalogAct, updateSuccessWithholdingCatalogAct } from "./withholding-catalog.action";
import { WithholdingCatalogService } from "../../services/withholding-catalog.service";



@Injectable()
export class WithholdingCatalogEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private withholdingCatalogService = inject(WithholdingCatalogService);
    private alerta = inject(AlertaService);

    findWithholdingCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findWithholdingCatalogAct),
            exhaustMap(action => this.withholdingCatalogService.findWithholdingCatalogById(action.id)
                .pipe(
                    map(withholding => loadWithholdingCatalogByIdAct({ withholding })),
                    catchError(error => {
                        if(error.status == 500) {
                            this.alerta.error("Se ha precentado un error interno", {
                                detail: error.error.details ,
                                onAccept: () => {
                                  this.router.navigate(['/withholdingsCatalog']);
                                }}); // . stack -> mas detalle
                            return of();
                        }else {
                            //return of(showMsgErrorAct({ error }));
                            this.alerta.error("Se ha precentado un error interno: ", {detail: error.message});
                            return of();
                        }
                    })
                ))
        )
    );

    saveWithholdingCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveWithholdingCatalogAct),
            exhaustMap(action => this.withholdingCatalogService.createWithholdingCatalog(action.withholdingNew)
                .pipe(
                    map(withholdingNew => saveSuccessWithholdingCatalogAct({ withholdingNew })),
                    /*catchError(error => (error.status == 400) ? of(setViolationsWithholdingCatalogAct({ withholdingForm: action.withholdingNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                    : of(showMsgErrorAct({ error }))*/
                    catchError(error => (error.status == 400) ? 
                        of(setViolationsWithholdingCatalogAct({ withholdingForm: action.withholdingNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                        : of(showMsgErrorAct({ error }))
                    //)
                    )
                )
            )
        )
    );

    /*showMsgErrorEffect$ = createEffect(() => this.actions$.pipe(
        ofType(showMsgErrorAct),
        tap((action) => {
            this.alerta.error("Se ha precentado un error interno");
        })
    ), { dispatch: false });*/
    showMsgErrorEffect$ = createEffect(() =>
            this.actions$.pipe(
              ofType(showMsgErrorAct),
              tap(action => {
                const detail = action.error?.error?.message || action.error?.message || null;
                //console.log('showMsgErrorEffect 111:');
                this.alerta.error(
                  'Se ha presentado un error interno Catalogo Beneficios',
                  detail ? { detail } : undefined
                );
                //console.log('showMsgErrorEffect 222:');
              })
            ),
            { dispatch: false }
          );

    saveSuccessWithholdingCatalogEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessWithholdingCatalogAct),
        tap(() => {
            this.router.navigate(['/withholdingsCatalog']);
            this.alerta.correct("Beneficio creado con exito!");
        })
    ), { dispatch: false });

    updateWithholdingCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateWithholdingCatalogAct),
            exhaustMap(action => this.withholdingCatalogService.updateWithholdingCatalog(action.withholdingUpdated)
                .pipe(
                    map(withholdingUpdated => updateSuccessWithholdingCatalogAct({ withholdingUpdated })),
                    catchError(error => {
                        if(error.status == 400) {
                            return of(setViolationsWithholdingCatalogAct({ withholdingForm: action.withholdingUpdated, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                        }else {
                            return of(showMsgErrorAct({ error }));
                        }
                    })
                )
            )
        )
    );

    updateSuccessWithholdingCatalogEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessWithholdingCatalogAct),
        tap(() => {
            this.router.navigate(['/withholdingsCatalog']);
            this.alerta.correct("Beneficio editado con exito!");
        })
    ), {dispatch: false});

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };
    
}